module.exports = __webpack_public_path__ + "media/images/niq-home-5e7dcbb75094e17883228c97a513e0af.svg";